import { appointmentStatus } from 'constants/ehrNoteEnums';
export var noteSchema;
(function (noteSchema) {
    noteSchema["intake"] = "intake";
    noteSchema["followUp"] = "followUp";
    noteSchema["notAttended"] = "notAttended";
    noteSchema["lateCancel"] = "lateCancel";
    noteSchema["couplesFamilyTherapyIntake"] = "couplesFamilyTherapyIntake";
    noteSchema["couplesFamilyTherapyFollowUp"] = "couplesFamilyTherapyFollowUp";
    noteSchema["minorTherapyIntake"] = "minorTherapyIntake";
    noteSchema["minorTherapyFollowUp"] = "minorTherapyFollowUp";
    noteSchema["providerUnscheduled"] = "providerUnscheduled";
    noteSchema["careNavigatorUnscheduled"] = "careNavigatorUnscheduled";
    noteSchema["careNavigatorInitial"] = "careNavigatorInitial";
    noteSchema["careNavigatorFollowUp"] = "careNavigatorFollowUp";
    noteSchema["adultMedManagementIntake"] = "adultMedManagementIntake";
    noteSchema["adultMedManagementFollowUp"] = "adultMedManagementFollowUp";
    noteSchema["minorMedManagementIntake"] = "minorMedManagementIntake";
    noteSchema["minorMedManagementFollowUp"] = "minorMedManagementFollowUp";
    noteSchema["medManagerUnscheduled"] = "medManagerUnscheduled";
})(noteSchema || (noteSchema = {}));
// Note schemas that are always read-only and significantly lighter weight
export var nonFormNoteSchemas;
(function (nonFormNoteSchemas) {
    nonFormNoteSchemas["legacyImport"] = "legacyImport";
})(nonFormNoteSchemas || (nonFormNoteSchemas = {}));
export var defaultBaseEHRNote = {
    sessionInfo: {
        status: appointmentStatus.completed,
    },
};
